import { render } from "./Change.vue?vue&type=template&id=015dfd79&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"

import "./Change.vue?vue&type=style&index=0&id=015dfd79&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-015dfd79"

export default script